import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone'
import { useDroppable } from '@dnd-kit/core';

const Container = styled.div`
    border-radius: 5px;
    /* border: ${props => props.isOver ? '1px solid var(--focus-color)' : '1px solid var(--primary-color)'}; */
    /* width: 100%;
    position: absolute;
    height: 100%; */
    height: 100%;
`

const Placeholder = styled.div`
    width: ${props => `calc(${props.width}px - ${props.month ? '1px' : '0.75rem'})`};
    height: ${props => `calc(${props.height}px - 2px)`};

    border-radius: 5px;
    
    border-left: ${props => `${props.month ? '1px' : '5px'} solid var(--secondary-color)`};
    border-top: 1px solid var(--secondary-collor);
    border-right: 1px solid var(--secondary-color);
    border-bottom: 1px solid var(--secondary-color);
    background-color: var(--primary-color);
    box-shadow: var(--box-shadow);
    opacity: 0.8;

    z-index: 5;
    position: absolute;
    padding: 0.15rem 0.5rem;
    margin-left: ${props => props.month ? 0 : '1px'};
    box-sizing: border-box;

    display: flex;
    flex-direction: column;

    font-size: 0.8rem;

`

const Droppable2 = ({id, children, boundingRect, extraProps, ...props}) => {
    const debug = false
    const view = extraProps.view
    const timeslot = moment(id.split('CALENDAR_')[1])
    const endTime = view === 'month' ? moment(id.split('CALENDAR_')[1]) : moment(id.split('CALENDAR_')[1]).add(extraProps.scheduleDuration['minute'],'minutes')
    const slots = view === 'month' ? 1 : extraProps.scheduleDuration['minute'] / parseInt(extraProps.step)
    const start = timeslot.format('h:mm')
    const end = moment(id.split('CALENDAR_')[1]).add(extraProps.scheduleDuration['minute'],'minutes').format('h:mma')

    const {
        setNodeRef,
        rect,
        isOver,
        node,
        over
    } = useDroppable({ id, data: { 
        view: extraProps.view,
        start_time: timeslot.toISOString(), 
        end_time: endTime.toISOString(),
        start_date: timeslot.startOf('day').toISOString(),
        end_date: endTime.startOf('day').toISOString(),
    }});
    

    return (
        <Container ref={setNodeRef} isOver={isOver} id={id}>
            {/* {["CALENDAR_2022-04-18 11:30","CALENDAR_2022-04-18 10:00","CALENDAR_2022-04-27"].includes(id) && */}
            {isOver &&
            <Placeholder month={view === 'month'}
                height={boundingRect && boundingRect['height'] * slots} 
                width={boundingRect && boundingRect['width']}>
                {view === 'month' ? null : `${start} - ${end}`}
            </Placeholder>}
            {children}
        </Container>
    )
}

export default Droppable2